export const MODAL_TRANSITION_DURATION_MS_DEFAULT = 300;
export const TEXT_MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
